import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ShareSVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.906.5L5.164 4.242l1.124 1.124 1.823-1.823V15.14h1.59V3.543l1.823 1.823 1.125-1.124L8.906.5zM3.341 7.19A2.397 2.397 0 00.956 9.574v9.54A2.397 2.397 0 003.341 21.5h11.13a2.397 2.397 0 002.386-2.385v-9.54a2.397 2.397 0 00-2.385-2.386h-2.386v1.59h2.386c.449 0 .795.346.795.796v9.54c0 .45-.346.795-.795.795H3.342a.782.782 0 01-.796-.795v-9.54c0-.45.346-.795.795-.795h2.385V7.19H3.341z",
  fill: "#111"
})));

export { ShareSVG as default };
//# sourceMappingURL=bundle.esm6.js.map
